export const COUNTRIES_ARRAY = [
  { name: 'United States', region: 'US', value: 'US' },
  { name: 'Canada', region: 'CA', value: 'Canada' },
  { name: 'Mexico', region: 'MX', value: 'Mexico' },
];
